import { render, staticRenderFns } from "./vFormSENSOR.vue?vue&type=template&id=0c9b4ef8&"
import script from "./vFormSENSOR.vue?vue&type=script&lang=js&"
export * from "./vFormSENSOR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports